import { createFileRoute } from "@tanstack/react-router";

import { PractitionerANSSearch } from "@/pages/account/PractitionerAnterioritySearch.tsx";

export const Route = createFileRoute("/_practitioner/search")({
  component: PractitionerANSSearch,
});
